
import { defineComponent, Ref, ref, watch, onMounted, computed } from "vue";
import Api from "@/services/Api";
import useEmitter from "@/composables/Emmiter";
import Title from "@/components/Title.vue"
import Button from "@/components/Button.vue"
import { LocationQueryValue, useRoute, useRouter } from "vue-router";
import Pagination from "@/components/Pagination.vue";
import { ElSkeleton, ElSkeletonItem } from 'element-plus'


interface AttendanceFilter {
  placa: string;
  veiculo: string;
  responsavel: string;
  data: any;
  status: string;
  idAtendimento?: string;
  codConcessionaria: string | LocationQueryValue[];
}

export default defineComponent({
  name: "Attendance",

  components: {
    Pagination,
    Title,
    Button,
    ElSkeleton,
    ElSkeletonItem
  },

  setup() {
    const emitter = useEmitter();
    const router = useRouter();
    const route = useRoute();

    const specificFormatData = (date: any) => new Date(date).toISOString().substr(0, 19).replace("T", " ");
    const maxLimitByPage = 10;
    const storeSelected: Ref<any> = ref("");
    const storeId = computed(() => route.query.storeId)

    const nomeConcessionaria: Ref<string> = ref('')
    const attendanceArray: Ref<any[]> = ref([]);
    const total: Ref<number> = ref(0);
    const page: Ref<number | null> = ref(null);

    const statusAttendance: string[] = ["Aberto", "Enviado", "Fechado", "Vendido", "Cancelado", "Andamento", "Precificar", "Pendente Aprovação", "Pago"];
    const atendimentoPaginationRef = ref<InstanceType<typeof Pagination> | null>(null);

    const attendanceFilter: Ref<AttendanceFilter> = ref({
      placa: "",
      veiculo: "",
      responsavel: "",
      data: "",
      status: "",
      idAtendimento:'',
      codConcessionaria: [],
    });

    const fastFind: Ref<any> = ref('');
    const lojaFixada: Ref<any> = ref(null)
    const skeleton: Ref<boolean> = ref(false);

    const attendanceFinded = ref(false);

    function handlePageChange(pageParam) {
      page.value = +pageParam;
      router.push({
        path: route.fullPath,
        query: {
          ...route.query,
          pagina: page.value
        }
      });
    }

    async function getAttendances(pageParam: number, limit: number, search = false) {
     
      try{
        // loadingAttendance.open();
        attendanceFinded.value = false;
        skeleton.value = true;
        // SEMPRE usa os parâmetros da URL atual, não do attendanceFilter
        const currentQuery = { ...route.query };
        
        // Prepara os parâmetros para a API baseado na URL
        const apiParams: any = {
          page: pageParam,
          limit,
        };
        
        // Adiciona storeId da URL se existir
        if (currentQuery.input) apiParams.input = fastFind.value = currentQuery.input;
        if (currentQuery.placa) apiParams.placa = currentQuery.placa;
        if (currentQuery.veiculo) apiParams.veiculo = currentQuery.veiculo
        if (currentQuery.responsavel) apiParams.responsavel = currentQuery.responsavel;
        if (currentQuery.status) apiParams.status = currentQuery.status
        if (currentQuery.idAtendimento) apiParams.idAtendimento = currentQuery.idAtendimento
        if (currentQuery.storeId) apiParams.codConcessionaria = currentQuery.storeId;
        if (currentQuery.codConcessionaria) apiParams.codConcessionaria = currentQuery.codConcessionaria;
        
        // Formata datas se existirem na URL
        if (attendanceFilter.value.data && attendanceFilter.value.data.length === 2) {
          apiParams.data = [
            specificFormatData(attendanceFilter.value.data[0]),
            specificFormatData(attendanceFilter.value.data[1])
          ];
        }
      
        const { data } = await Api.get("getAttendancesByPage", apiParams);
        
        total.value = data.total;
        page.value = pageParam;
        
        if (!search) {
          attendanceArray.value = [...attendanceArray.value, ...data.atendimentos];
        } else {
          attendanceArray.value = data.atendimentos;
        }

        attendanceArray.value.length === 0 ? attendanceFinded.value = true : attendanceFinded.value = false;        


        if(currentQuery.storeId) {
          attendanceArray.value.length ? nomeConcessionaria.value = attendanceArray.value[0].nomeFantasia : '';
        }
      }catch(error) {
        skeleton.value = false;
        console.log(error)
      } finally {
        skeleton.value = false;
      }

    }

    function redirectToAttendanceDetails(id: number): void {
      router.push({
        path: `/lojas/atendimentos/detalhes`,
        query: { id: id.toString() }
      });
    }

    emitter.on("Filter-Atendimentos", async (props:any) => {
      let lojas: any = '';
      if(props.codConcessionariaTeste != undefined) { lojas = props.codConcessionariaTeste.join(',') }  
      attendanceFilter.value = {
        placa: props.placa,
        veiculo: props.veiculo,
        responsavel: props.responsavel,
        data: props.data,
        status: props.status,
        idAtendimento: props.idAtendimento,
        codConcessionaria: lojas,
      }
      fastFind.value = "";
      if (atendimentoPaginationRef.value) {
        atendimentoPaginationRef.value.resetPage(1);
      }

      // Criar objeto com apenas os valores não vazios/não nulos
      const filteredParams: any = {};

      // Filtra apenas os valores que não são vazios, null, undefined ou array vazio
      Object.entries(attendanceFilter.value).forEach(([key, value]) => {
        if (value !== "" && value !== null && value !== undefined && !(Array.isArray(value) && value.length === 0)) {
          filteredParams[key] = value.toString();
        }
      });

      // Adiciona storeId da URL se existir
      if (route.query.storeId) {
        filteredParams.storeId = route.query.storeId;
      }

      // Sempre adiciona a página 1
      filteredParams.pagina = 1;

      // Atualiza a URL com os parâmetros filtrados
      await router.replace({ 
        path: route.path, 
        query: filteredParams 
      });

      // // FAZ A REQUISIÇÃO DIRETAMENTE (garantido)
      // await getAttendances(1, maxLimitByPage, true);
    });

    function getLocalStorage(){
      lojaFixada.value = JSON.parse(localStorage.getItem('lojaFixada') as any)      
      if(lojaFixada.value){
        attendanceFilter.value.codConcessionaria = lojaFixada.value && lojaFixada.value.id

        router.push({ path: route.path, query: { ...route.query, storeId: lojaFixada.value.id } });
      }
    }

    async function resetObject(obj) {
      for (const prop in obj) {
        obj[prop] = typeof obj[prop] === "object" ? {} : "";
      }
    }

    async function enviar() {
      if(fastFind.value != ""){
        resetObject(attendanceFilter.value);  
        await router.push({ path: route.path, query: { ...route.query, pagina: 1, input: fastFind.value } });      
      } else {
        // ATUALIZA A URL para refletir o estado atual (sem input)
        const currentQuery = { ...route.query };
        const newQuery = { ...currentQuery };

        // Remove input
        delete newQuery.input;
        await router.push({ path: route.path, query: newQuery }); 
      }

      if (atendimentoPaginationRef.value) atendimentoPaginationRef.value.resetPage(1);
      
      getAttendances(1, maxLimitByPage, true);
    }

    watch(
      () => route.query,
      (newQuery, oldQuery) => {
        // 1. Sincroniza a paginação visual se o parâmetro 'pagina' existir na URL
        const paginaNaUrl = newQuery.pagina ? Number(newQuery.pagina) : 1;
        if (atendimentoPaginationRef.value) {
          atendimentoPaginationRef.value.resetPage(paginaNaUrl);
        }

        // 2. Lógica específica: Se o storeId mudou, resetamos o filtro interno
        if (newQuery.storeId !== oldQuery?.storeId) {
          attendanceFilter.value.codConcessionaria = "";
        }

        // 3. Dispara a requisição ÚNICA para qualquer mudança na URL
        // Usamos os valores vindos da URL para garantir que o que o usuário vê é o que ele recebe
        getAttendances(paginaNaUrl, maxLimitByPage, true);
      },
      { deep: true }
    );

    onMounted(async () => {
      getLocalStorage();

      const page = route.query.pagina ? +route.query.pagina : 1;
      if(!route.query.pagina) router.push({path: route.fullPath, query: {...route.query, pagina: 1}})
      
      if (atendimentoPaginationRef.value) atendimentoPaginationRef.value.resetPage(page)
    });

    return {
      page,
      maxLimitByPage,
      total,
      attendanceArray,
      getAttendances,
      redirectToAttendanceDetails,
      attendanceFilter,
      history,
      console,
      statusAttendance,
      storeSelected,
      lojaFixada,
      fastFind,
      nomeConcessionaria,
      storeId,
      route,
      handlePageChange,
      atendimentoPaginationRef,
      enviar,
      attendanceFinded,
      skeleton
    };
  },
});
